import React, {useEffect, useMemo, useState} from 'react';
import { useNavigate } from 'react-router-dom';

import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import TabsComponent from '../../../commons/components/Tabs/TabsComponent';
import MainLayout from '../../../commons/layout/MainLayout';
import HallOfFameComponent from './../components/hallOfFame';
import RankingComponent from './../components/ranking';
import BacktoTopComponent from "../../../commons/components/BackToTop";
import ROUTERS from "../../../commons/constans/router";

const AwardPageContainer = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  const rankingTab = <RankingComponent tab={tab}/>;
  const hallOfFameTab = <HallOfFameComponent />;

  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  }
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    })
  }, [])

  const handleChangeTab = (index) => {
    setTab(index)
  }

  return (
    <>
      <MainLayout
        pageID={'ranking-page'}
        displayBottomNav={false}
        activeNav={'GIFTBOX'}
      >
        <HeaderHs2
          labelRight={false}
          labelLeft={true}
          title="랭킹"
          handleLabelLeft={() => handleLeftClick()}
        />
        <div className="wrapper">
          <TabsComponent
            tabHeadings={['진행중인 어워즈', '명예의 전당']}
            tabContents={[rankingTab, hallOfFameTab]}
            activeIndex={tab}
            handleChangeTab={handleChangeTab}
          />
        </div>
        <BacktoTopComponent />
      </MainLayout>
    </>
  );
};

export default AwardPageContainer;
